<template>
  <Navbar :title="title" :class="{'show': showNavbar}">
    <template v-slot:close>
      <div @click="$emit('close')" class="close">Cerrar</div>
    </template>
    <template v-slot:content>
      <div class="form-section">
        <div class="form-section__title">Datos personales</div>
        <div class="form-group">
          <label for="us-name">Nombre</label>
          <input v-model="form.name" class="input" type="text" id="us-name" maxlength="100">
          <span v-if="errors.name" class="error">{{ errors.name }}</span>
        </div>
        <div class="form-group">
          <label for="us-lastName">Apellido</label>
          <input v-model="form.lastName" class="input" type="text" id="us-lastName" maxlength="100">
          <span v-if="errors.lastName" class="error">{{ errors.lastName }}</span>
        </div>
        <div class="form-group">
          <label for="us-doc">DNI</label>
          <input v-model="form.document" class="input" type="text" id="us-doc" maxlength="8">
          <span v-if="errors.document" class="error">{{ errors.document }}</span>
        </div>
      </div>

      <div class="form-section">
        <div class="form-section__title">Contrato</div>
        <div class="form-group">
          <label for="us-position">Cargo</label>
          <select v-model="form.positionSelect" class="select" id="us-position">
            <option value="" disabled>Selecciona un cargo</option>
            <option v-for="c in cargoOptions" :key="c" :value="c">{{ c }}</option>
          </select>
          <span v-if="errors.position" class="error">{{ errors.position }}</span>
        </div>
        <div v-if="form.positionSelect === 'Otro'" class="form-group">
          <label for="us-position-other">Especifica el cargo</label>
          <input v-model="form.positionOther" class="input" type="text" id="us-position-other" maxlength="80" placeholder="Cargo">
        </div>
        <div class="form-group">
          <label for="us-estate">Local</label>
          <select v-model="form.estateId" class="select" id="us-estate">
            <option value="" disabled>Selecciona un local</option>
            <option v-for="e in estates" :key="e.id" :value="e.id">{{ e.description }}</option>
          </select>
          <span v-if="errors.estateId" class="error">{{ errors.estateId }}</span>
        </div>
        <div class="form-group">
          <label for="us-type">Tipo de contrato</label>
          <select v-model="form.typeDisplay" class="select" id="us-type">
            <option value="fixed">Fijo — sueldo mensual</option>
            <option value="variable-hour">Variable — por hora</option>
            <option value="variable-day">Variable — por día</option>
          </select>
          <span v-if="errors.type" class="error">{{ errors.type }}</span>
        </div>
        <div v-if="form.typeDisplay === 'fixed'" class="form-group">
          <label for="us-salary">Sueldo mensual (S/)</label>
          <input v-model.number="form.monthlySalary" class="input" type="number" id="us-salary" min="0" step="0.01">
          <span v-if="errors.monthlySalary" class="error">{{ errors.monthlySalary }}</span>
        </div>
        <div v-if="form.typeDisplay && form.typeDisplay !== 'fixed'" class="form-group">
          <label for="us-rate">Tarifa (S/ por {{ form.typeDisplay === 'variable-hour' ? 'hora' : 'día' }})</label>
          <input v-model.number="form.rate" class="input" type="number" id="us-rate" min="0" step="0.01">
          <span v-if="errors.rate" class="error">{{ errors.rate }}</span>
        </div>
        <div class="form-group">
          <label>Estado</label>
          <label class="checkbox-label">
            <input type="checkbox" v-model="form.active">
            Activo
          </label>
        </div>
      </div>

      <!-- Datos de depósito (opcional) -->
      <div class="form-section">
        <div class="form-section__title">Pago</div>
        <div class="form-group">
          <label for="us-pay-method">Forma de pago (opcional)</label>
          <select v-model="form.paymentMethod" class="select" id="us-pay-method">
            <option value="">— Sin datos —</option>
            <option value="savings">Ahorros</option>
            <option value="checking">Corriente</option>
            <option value="yape">Yape</option>
            <option value="plin">Plin</option>
          </select>
          <span v-if="errors.method" class="error">{{ errors.method }}</span>
        </div>
        <template v-if="isAccountMethod">
          <div class="form-group">
            <label for="us-bank">Banco</label>
            <select v-model="form.bankSelect" class="select" id="us-bank">
              <option value="">Selecciona un banco</option>
              <option v-for="b in bankOptions" :key="b" :value="b">{{ b }}</option>
            </select>
          </div>
          <div v-if="form.bankSelect === 'Otro'" class="form-group">
            <label for="us-bank-other">Nombre del banco</label>
            <input v-model="form.bankOther" class="input" type="text" id="us-bank-other" maxlength="40" placeholder="Nombre del banco">
            <span v-if="errors.bank" class="error">{{ errors.bank }}</span>
          </div>
          <div class="form-group">
            <label for="us-account">N° de cuenta</label>
            <input v-model="form.accountNumber" class="input" type="text" id="us-account" maxlength="20" placeholder="Solo dígitos" inputmode="numeric">
            <span v-if="errors.accountNumber" class="error">{{ errors.accountNumber }}</span>
          </div>
          <div class="form-group">
            <label for="us-cci">CCI</label>
            <input v-model="form.cci" class="input" type="text" id="us-cci" maxlength="20" placeholder="20 dígitos" inputmode="numeric">
            <span v-if="errors.cci" class="error">{{ errors.cci }}</span>
          </div>
        </template>
        <div v-else-if="isWalletMethod" class="form-group">
          <label for="us-phone">Celular</label>
          <input v-model="form.phone" class="input" type="text" id="us-phone" maxlength="9" placeholder="9 dígitos" inputmode="numeric">
          <span v-if="errors.phone" class="error">{{ errors.phone }}</span>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <button :disabled="progress" :class="{'is-loading': progress}" @click="save" class="btn">
        <span v-if="!progress">Guardar cambios</span>
      </button>
    </template>
  </Navbar>
  <Shadow :class="{'show': showNavbar}"/>
</template>

<script>
import Navbar from '@/components/Navbar'
import Shadow from '@/components/Shadow'
import { db, FieldValue } from '@/firebase/firebaseConfig'
import * as yup from 'yup'
import { BANK_OPTIONS, CARGO_OPTIONS, resolvePosition, positionToForm, paymentSchema, buildPayment, paymentValues, isAccountMethod, isWalletMethod } from './paymentData'

yup.setLocale({
  mixed: { required: 'Este campo es obligatorio' },
  number: { positive: 'Debe ser mayor a 0' }
})

export default {
  name: 'UpdateStaff',
  components: { Navbar, Shadow },
  props: {
    showNavbar: { type: Boolean, default: false },
    title: { type: String, default: 'Editar personal' },
    data: { type: Object, default: () => ({}) }
  },
  emits: ['close', 'updated'],
  data () {
    return {
      form: {},
      estates: [],
      errors: {},
      progress: false,
      bankOptions: BANK_OPTIONS,
      cargoOptions: CARGO_OPTIONS
    }
  },
  computed: {
    isAccountMethod () { return isAccountMethod(this.form.paymentMethod) },
    isWalletMethod () { return isWalletMethod(this.form.paymentMethod) }
  },
  watch: {
    showNavbar (val) {
      if (val && this.data) { this.loadEstates(); this.initForm() }
    }
  },
  methods: {
    async loadEstates () {
      if (this.estates.length) return
      try {
        const snap = await db.collection('estates').orderBy('description').get()
        this.estates = snap.docs.map(d => ({ id: d.id, description: d.data().description }))
      } catch (e) {
        this.$toast.error('Error al cargar locales')
      }
    },
    initForm () {
      const d = this.data
      let typeDisplay = 'fixed'
      if (d.type === 'variable') {
        typeDisplay = d.rateUnit === 'day' ? 'variable-day' : 'variable-hour'
      }
      const p = d.payment || null
      let bankSelect = ''
      let bankOther = ''
      if (p && (p.method === 'savings' || p.method === 'checking') && p.bank) {
        // If the saved bank isn't in the known list, treat it as "Otro".
        if (BANK_OPTIONS.includes(p.bank) && p.bank !== 'Otro') {
          bankSelect = p.bank
        } else {
          bankSelect = 'Otro'
          bankOther = p.bank
        }
      }
      const { positionSelect, positionOther } = positionToForm(d.position)
      this.form = {
        name: d.name || '',
        lastName: d.lastName || '',
        document: d.document || '',
        positionSelect,
        positionOther,
        estateId: d.estate ? d.estate.id : '',
        typeDisplay,
        monthlySalary: d.monthlySalary || 0,
        rate: d.rate || 0,
        active: d.active !== false,
        paymentMethod: p ? (p.method || '') : '',
        bankSelect,
        bankOther,
        accountNumber: p ? (p.accountNumber || '') : '',
        cci: p ? (p.cci || '') : '',
        phone: p ? (p.phone || '') : ''
      }
      this.errors = {}
    },
    async save () {
      try {
        this.progress = true
        this.errors = {}
        const schemaShape = {
          name: yup.string().max(100).required().label('Nombre'),
          lastName: yup.string().max(100).required().label('Apellido'),
          document: yup.string().matches(/^\d{8}$/, 'DNI debe tener 8 dígitos').required().label('DNI'),
          position: yup.string().max(80).required('Selecciona un cargo').label('Cargo'),
          estateId: yup.string().required('Selecciona un local').label('Local')
        }
        if (this.form.typeDisplay === 'fixed') {
          schemaShape.monthlySalary = yup.number().positive().required().label('Sueldo')
        } else {
          schemaShape.rate = yup.number().positive().required().label('Tarifa')
        }
        Object.assign(schemaShape, paymentSchema)
        await yup.object().shape(schemaShape).validate({ ...this.form, position: resolvePosition(this.form), ...paymentValues(this.form) }, { abortEarly: false })

        const isVariable = this.form.typeDisplay !== 'fixed'
        const estate = this.estates.find(e => e.id === this.form.estateId)
        const payload = {
          name: this.form.name.trim(),
          lastName: this.form.lastName.trim(),
          document: this.form.document.trim(),
          position: resolvePosition(this.form),
          estate: { id: estate.id, description: estate.description },
          type: isVariable ? 'variable' : 'fixed',
          payment: buildPayment(this.form),
          active: this.form.active,
          updatedAt: FieldValue.serverTimestamp()
        }
        if (!isVariable) {
          payload.monthlySalary = this.form.monthlySalary
          payload.rate = 0
          payload.rateUnit = 'hour'
        } else {
          payload.monthlySalary = 0
          payload.rate = this.form.rate
          payload.rateUnit = this.form.typeDisplay === 'variable-hour' ? 'hour' : 'day'
        }

        await db.collection('staff').doc(this.data.id).update(payload)
        this.$emit('updated', { id: this.data.id, ...payload })
        this.$emit('close')
        this.$toast.success('Personal actualizado')
      } catch (err) {
        if (err.inner) {
          err.inner.forEach(e => { if (e.path) this.errors[e.path] = e.message })
        } else {
          this.$toast.error('Error al guardar')
        }
      } finally {
        this.progress = false
      }
    }
  }
}
</script>
